import { Component } from '@angular/core';
import { IntercomChatbotService } from './core/services/intercom-chatbot.service';
import { GlobalStateService } from './shared/states';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'SSO-Dashboard';
  showIntercom: boolean = true;
  constructor(
    private intercomService: IntercomChatbotService,
    private globalState: GlobalStateService
  ) {}

  ngOnInit(): void {
    this.globalState.hideIntercomDummyEvent.subscribe((response) => {
      this.showIntercom = response;
    });

    setTimeout(async () => {
      if (!(<any>window).Intercom) {
        await this.intercomService.setIntercomScript();
        await this.intercomService.setupIntercom();
        setTimeout(() => {
          this.showIntercom = false;
        }, 800);
      }
    }, 5000);
  }
  /**
   * Load script and setup intercom
   */
  async loadScript() {
    await this.intercomService.setIntercomScript();
    await this.intercomService.setupIntercom();
    if ((<any>window).Intercom) {
      (<any>window).Intercom('show');
      setTimeout(() => {
        this.showIntercom = false;
      }, 800);
    }
  }
}
